import React from 'react';
import PropTypes from 'prop-types';
import {
    AnalyticsCardWrapper,
    AnalyticsCardContent,
    AnalyticsCardHeader,
    AnalyticsCardIcon,
    AnalyticsCardTitle,
    AnalyticsCardValue,
} from '@components/ui/analytics/style';

/**
 * Analytics Card Component - A simple, reusable card for displaying analytics data
 * @param {Object} header - The header of the card
 * @param {string} title - The title of the card
 * @param {string} value - The value of the card
 * @param {Object} change - The change of the card
 * @param {string} icon - The icon of the card
 * @param {Array} chartData - The chart data of the card
 */

const AnalyticsCard = ({
    title,
    value,
    header = null,
    icon = null,
}) => {
    return (
        <AnalyticsCardWrapper>
            <AnalyticsCardContent>
                <AnalyticsCardHeader>
                    {header ? header : (
                        <>
                            {icon ? <AnalyticsCardIcon>{icon}</AnalyticsCardIcon> : null}
                            <AnalyticsCardTitle>{title}</AnalyticsCardTitle>
                        </>
                    )}
                </AnalyticsCardHeader>
                <AnalyticsCardValue>{value}</AnalyticsCardValue>
            </AnalyticsCardContent>
        </AnalyticsCardWrapper>
    );
};

AnalyticsCard.propTypes = {
    header: PropTypes.node,
    icon: PropTypes.node,
    title: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired
};

export default AnalyticsCard;

